import React, { useEffect, useState } from 'react';
import HomeLf from './HomeLf';
import './projetos.css';
import { db, firebaseAuth } from '../utils/firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, doc, getDocs, updateDoc } from 'firebase/firestore';
import Background from 'three/examples/jsm/renderers/common/Background.js';
import { Center } from '@react-three/drei';
import axios from 'axios';

import logo from '../assets/version2/logo.png'

import listicon from "../assets/version2/listicon.png";
import gridicon from "../assets/version2/gridicon.png";
import atentionicon from "../assets/version2/atentionicon.png";
import msgred from "../assets/version2/msgred.png";
import upload3d from "../assets/version2/upload3d.png";
import boxpendencias from "../assets/version2/boxpendencias.png";
import editarprojeto from "../assets/version2/editarprojeto.png";
import colaboradores from "../assets/version2/colaboradores.png";
import Rodape from './Rodape';


function Main(params) {

  const navigate = useNavigate();


  const [current, setCurrent] = useState('');
  const [dataA, setDataA] = useState([]);
  const [filtrados, setFiltrados] = useState([]);
  const [filtradosB, setFiltradosB] = useState([]);
  const [hide, setHide] = useState('none');
  const [target, setTarget] = useState([]);

  const [editData, setEditData] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [corSim, setCorSim] = useState(true);


const [aberto, setAberto] = useState('none');
const [projetoNome, setProjetoNome] = useState('');
const [descricao, setDescricao] = useState('');
const [comentariosIniciais, setComentariosIniciais] = useState('');

const [concluidos, setConcluidos] = useState(0);
const [emAndamento, setEmAndamento] = useState(0);
const [editTarget, setEditTarget] = useState('');

const [dataColaborador, setDataColaborador] = useState([]);
const [dataColaboradorB, setDataColaboradorB] = useState([]);


  const [countMp, setCountMp] = useState(1);
  const [mapeA, setMapeA] = useState([1]);
  const [filterBtn, setFilterBtn] = useState(0);


  var trad = [];



  const [colaboradoresData, setColaboradoresData] = useState([]);

var count01 = 0;



async function master(params) {

      

  var objMaster = [];
  var objMaster2 = [];

   


  onAuthStateChanged(firebaseAuth, async (currentUser) => {
    if (currentUser) {
      var usuarioLogado = currentUser.email;
      setCurrent(usuarioLogado);

  fetch('https://kollabity.uk/api/consultausuario', {
    method: 'POST',
    body: JSON.stringify({

      email: usuarioLogado
   
    }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {

 
      setColaboradoresData(data.colaboradores)
      
      setIsAdmin(data.admin)
   
     })
     .catch((err) => {
        console.log(err.message);
     });









  await fetch('https://kollabity.uk/api/consulta', {
    method: 'POST',
    body: JSON.stringify({
      email: usuarioLogado
  
    }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {
 
       console.log('DATAAA', data);
        setDataColaborador(data);
        setDataColaboradorB(data);
     })
     .catch((err) => {

  
     });







         await fetch('https://kollabity.uk/api/consultarelatorio', {
    method: 'POST',
    body: JSON.stringify({
      email: usuarioLogado
  
    }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {
 
       console.log('DATAAAAAAAAAAAAAAAAAAAAAAAAA', data);  

                    var criados = data;          
                    var final = 0;             
                    var andamento = 0;             

                   for (let i = 0; i < criados.length; i++) {                                           
                   if(criados[i].andamento == false){
                      final = final + 1;
                   } else {
                    andamento = andamento + 1;
                   }
                      }

                      setConcluidos(final);
                       setEmAndamento(andamento);
                      console.log('asdasd',final);

                      criados.sort(function(a, b) {

                        return a.nomeDoProjeto.localeCompare(b.nomeDoProjeto);
                    
                    });



                    setFiltrados(criados);
                    setFiltradosB(criados);
                    console.log(criados);
              //      console.log('nova data', new Date(criados[0].dataDeCriacao.seconds*1000))
            







     })
     .catch((err) => {

  
     });























      
    };
  });




 







}







async function buscarProjeto(params2) {

          fetch('https://kollabity.uk/api/consultaprojeto', {
                    method: 'POST',
                    body: JSON.stringify({
                
                      id: params2
                   
                    }),
                    headers: {
                      'Content-type': 'application/json; charset=UTF-8',
                    },
                  })
                     .then((response) => response.json())
                     .then((data) => {
                  
                      document.querySelector('.editInputTitle').value = data.nomeDoProjeto;
                      document.querySelector('.editInputDescricao').value = data.descricao;
                      document.querySelector('.editInputInfos').value = data.comentariosIniciais;
                
                        setEditTarget(params2);
                  
                   
                     })
                     .catch((err) => {
                        console.log(err.message);
                     });
                




}







  function emandamentoFiltro() {
    var tradeFiltro1 = [];
    for (let i = 0; i < filtradosB.length; i++) {
      if(filtradosB[i].andamento == true){
        tradeFiltro1.push(filtradosB[i]);
      }
    }
    setFiltrados(tradeFiltro1);


    var tradeFiltroB1 = [];
    for (let i = 0; i < dataColaboradorB.length; i++) {
      if(dataColaboradorB[i].andamento == true){
        tradeFiltroB1.push(dataColaboradorB[i]);
      }
    }
    setDataColaborador(tradeFiltroB1);




  }


  function concluidosFiltro() {
        var tradeFiltro2 = [];
    for (let i = 0; i < filtradosB.length; i++) {
      if(filtradosB[i].andamento == false){
        tradeFiltro2.push(filtradosB[i]);
      }
    }
    setFiltrados(tradeFiltro2);


        var tradeFiltroB2 = [];
    for (let i = 0; i < dataColaboradorB.length; i++) {
      if(dataColaboradorB[i].andamento == false){
        tradeFiltroB2.push(dataColaboradorB[i]);
      }
    }
    setDataColaborador(tradeFiltroB2);




  }


  function todosFilter() {
    setFiltrados(filtradosB);
    setDataColaborador(dataColaboradorB);
  }







function fetchMaster(params) {
  




     const options = {
      url: 'https://kollabity.uk/api/tokenviewer',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      }
   
    };
    axios(options)
      .then(response => {
    //    setTokenT(response.data.access_token);
     //   console.log(response.data.access_token);
     window.location.href = `/projeto?urn=${params}&token=${response.data.access_token}`;
      });
  


}







  async function finishMaster() {
   
    
        await updateDoc(doc(db, 'projetos', editTarget), {
            
      
                nomeDoProjeto: projetoNome,
                descricao: descricao,
                comentariosIniciais: comentariosIniciais,
               
          });
         
          
          
           window.location.reload();
          

    }
















useEffect(()=> {
  master();
},[])




function mapear() {
            
  setCountMp(countMp + 1);

  for (let i = 0; i < countMp; i++) {
      trad.push(i);
      
  }
  trad.push(countMp);
//  console.log(trad);
  setMapeA(trad);
}












 async function enviarColaborador() {
  
  var objj = colaboradoresData;

  console.log('objj ', objj);
  function mast(params) {
    for (let i = 0; i < objj.length; i++) {
     if(objj[i].split('#io71239923')[0].replaceAll(' ', '') == params) {
         return objj[i];
     }
  }  
  }





var colaboradoresTrade = []
for (let i = 0; i < document.querySelectorAll('.dastasColaboradores').length; i++) {
colaboradoresTrade.push(`${mast(document.querySelectorAll('.dastasColaboradores')[i].querySelectorAll('select')[0].value).split('#io71239923')[1] } ###master ${mast(document.querySelectorAll('.dastasColaboradores')[i].querySelectorAll('select')[0].value).split('#io71239923')[2].replaceAll(' ', '')} ###master ${document.querySelectorAll('.dastasColaboradores')[i].querySelectorAll('select')[1].value} ###master ${document.querySelectorAll('.dastasColaboradores')[i].querySelectorAll('select')[0].value}`) 
}

//console.log(colaboradoresTrade);

var tradeEmails = []
for (let i = 0; i < colaboradoresTrade.length; i++) {
    tradeEmails.push(colaboradoresTrade[i].split('###master')[0].replaceAll(' ', ''))
}





await fetch('https://kollabity.uk/api/vincularcolaborador', {
  method: 'POST',
  body: JSON.stringify({
    colaboradores: colaboradoresTrade,
      emails: tradeEmails,
      target: target

  }),
  headers: {
    'Content-type': 'application/json; charset=UTF-8',
  },
})
   .then((response) => response.json())
   .then((data) => {
    window.location.reload();
     

   })
   .catch((err) => {
 window.location.reload();

   });



  
















 }














    return (
      <>
      
      











<div style={{backgroundColor: 'rgba(100,100,100,0.5)', width: '100%', height: '100%', position: 'absolute',
display: aberto, justifyContent: 'center', alignItems: 'center'

}}>


<div style={{ width: '500px',borderRadius: '16px', backgroundColor: '#fff', paddingBottom: '30px'}}>
<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px',
paddingLeft: '20px', paddingRight: '20px',
alignItems: 'center'

}}>
<div><img src={logo} style={{width: '120px'}}></img></div>
<div style={{cursor: 'pointer'}}
onClick={()=> {setAberto('none');
                      document.querySelector('.editInputTitle').value = '';
                      document.querySelector('.editInputDescricao').value = '';
                      document.querySelector('.editInputInfos').value = '';
}}
>    <i class="bi bi-x" style={{fontSize: '25px'}}
/>
</div>

</div>
<div>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>

<div style={{padding: '0px 30px', marginTop: '30px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>Título do Projeto</div>
<input className='editInputTitle' style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Insira o título do projeto"
  onChange={(e) => setProjetoNome(e.target.value)  }
></input>
</div>


<div style={{padding: '0px 30px', marginTop: '20px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>Descrição do Projeto</div>
<input className='editInputDescricao' style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Insira a descrição do projeto"
  onChange={(e) => setDescricao(e.target.value)  }
></input>
</div>




<div style={{padding: '0px 30px', marginTop: '20px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>informações do Projeto</div>
<input className='editInputInfos' style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Insira informações do projeto"
  onChange={(e) => setComentariosIniciais(e.target.value)  }
></input>
</div>

<div style={{padding: '0px 30px', marginTop: '20px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>informações do Projeto</div>
<a style={{cursor: 'pointer', textDecoration: 'underline'}}
onClick={()=> navigate(`/uploadmaster?idproject=${editTarget}`)}
>Atualizar arquivo 3D</a>
</div>










<div style={{display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%', padding: '0px 30px', marginTop: '28px'}}>
        <div style={{cursor: 'pointer', width: '150px', height: '35px', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: '600', color: '#fff', backgroundColor: '#985EAC'}}
        onClick={()=> finishMaster()}
        >Editar Projeto </div>
</div>

</div>



<div style={{display: 'none'}}>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>



<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-7" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center'}}>
    

<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Email do colaborador"></input>
</div>
<div className="col-5" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', color: 'black'}}>
    <select style={{width: '100%', height: '35px', borderRadius: '10px'}}>
    <option value="Administrador"  style={{border: 'none'}}>Administrador</option>
  <option value="Gerente">Gerente</option>
  <option value="Engenheiro">Engenheiro</option>
  <option value="Prestador de serviços">Prestador de serviços</option>
    </select>

</div>
</div>






</div>






</div>

</div>
































































      
      
      <div style={{backgroundColor: 'rgba(100,100,100,0.5)', width: '100%', height: '100%', position: 'absolute',
 display: hide ,justifyContent: 'center', alignItems: 'center'

}}>


<div style={{ width: '500px',borderRadius: '16px', backgroundColor: '#fff', paddingBottom: '30px'}}>
<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px',
paddingLeft: '20px', paddingRight: '20px',
alignItems: 'center'

}}>
<div><img src={logo} style={{width: '120px'}}></img></div>
<div>    <i class="bi bi-x" style={{fontSize: '25px', cursor: 'pointer'}}
onClick={()=> setHide('none')}
/>
</div>

</div>
<div>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Editar Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center',backgroundColor: '#985EAC', color: '#fff' }}>Colaboradores</div>
</div>

<div style={{padding: '0px 30px', marginTop: '30px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>Colaborador</div>
{mapeA.map((data, index)=> {
return <>
<div className="dastasColaboradores" style={{display: 'flex', gap: '10px', marginTop: '10px'}}>
<select style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}}
>
  {colaboradoresData.map((data, index)=> {
    return <option>{data.split('#io71239923')[0]}</option>
  })}
<option>Selecione o colaborador</option>

</select>


<select style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}}
>
<option value="administrador"  style={{border: 'none'}}>Administrador</option>
  <option value="gerente">Gerente</option>
  <option value="engenheiro">Engenheiro</option>
  <option value="prestadordeservicos">Prestador de serviços</option>

</select>
</div>
</>
})}


<div style={{fontSize: '24px', color: 'rgba(1, 105, 1, 0.75)',
marginLeft: '10px', cursor: 'pointer'

}}
onClick={()=> mapear()}
> +</div>


</div>



<div style={{display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%', padding: '0px 30px', marginTop: '28px'}}>
        <div
         style={{width: '120px', cursor: 'pointer', height: '35px', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: '600', color: '#fff', backgroundColor: '#985EAC'}}
         onClick={()=> enviarColaborador()}
        >Salvar</div>
</div>

</div>



<div style={{display: 'none'}}>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>



<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-7" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center'}}>
    

<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Email do colaborador"></input>
</div>
<div className="col-5" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', color: 'black'}}>
    <select style={{width: '100%', height: '35px', borderRadius: '10px'}}>
    <option value="Administrador"  style={{border: 'none'}}>Administrador</option>
  <option value="Gerente">Gerente</option>
  <option value="Engenheiro">Engenheiro</option>
  <option value="Prestador de serviços">Prestador de serviços</option>
    </select>

</div>
</div>






</div>






</div>

</div>
      
      
      
      
      
      
      
      
        <div>



<HomeLf/>
  <div className="responsivemenu"></div>

<div
  className="col-12"
  style={{
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    marginTop: 50
  }}
>
  <div className="col-10">
    <div>
      <div style={{ marginBottom: 40 }}>
        <h2 className="meusProjetos">Meus Projetos </h2>
      </div>
     




 <div
        style={{ marginBottom: 50, marginLeft: "-30px" }}
        className="d-flex row wrap"
      >
        <div
          className="col-12 col-sm-4 d-flex flex-row flex-sm-column  rowtostart"
          style={{
            borderRight: "1px solid #BDC1CA",
            display: "flex",
     
            alignItems: "center",
            fontFamily: "Inter, serif",
           
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{ display: "flex", flexFlow: "column" }}>
            Pendencias (Total)
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
               
                fontWeight: 600
              }}
            >
              {filtrados.length}
            </a>
          </div>
        </div>
        <div
          className="col-12 col-sm-4  d-flex flex-row flex-sm-column"
          style={{
            borderRight: "1px solid #BDC1CA",
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{ display: "flex", flexFlow: "column" }}>
                   <div className="tituloCards" style={{ display: "flex" }}>
            Projetos:{" "}
            <div>
              <a className="emAndamento"> Em Andamento</a>
            </div>
          </div>
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
              {emAndamento}
            </a>
          </div>
        </div>
        <div
          className="col-12 col-sm-4 d-flex flex-row flex-sm-column"
          style={{
            borderRight: "1px solid #BDC1CA",
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            borderRight: 'none',
            fontWeight: 400
          }}
        >
          <div style={{ display: "flex", flexFlow: "column" }}>
          <div className="tituloCards" style={{ display: "flex"}}>
            Projetos:{" "}
            <div>
              <a className="concluido" style={{padding: '5px 8px'}}> Concluído</a>
            </div>
          </div>
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
         {concluidos}
            </a>
          </div>
        </div>
        <div
          className="col-3 d-flex justify-content-center"
          style={{
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
         
        </div>
      </div>







      <div
        style={{
          display: "flex",
          flexFlow: "row nowrap",
          justifyContent: "space-between"
        }}
      >
        <div style={{ display: "flex" }}>
          <div
            style={{
              color: `${filterBtn == 0 ? "#985EAC" : '#565D6D'}`,
              borderBottom: `${filterBtn == 0 ? "4px solid #985EAC" : ''}`,
              fontWeight: `${filterBtn == 0 ? "bold" : '400'}`,
              paddingBottom: 5,
              width: 70,
              textAlign: "center",
              cursor: 'pointer'
            }}
            onClick={()=> {
              todosFilter();
              setFilterBtn(0);
            }}
          >
            Todos
          </div>
          <div
            className="seletores"
            style={{
              marginLeft: 0,
              paddingBottom: 5,
              color: `${filterBtn == 1 ? "#985EAC" : '#565D6D'}`,
              borderBottom: `${filterBtn == 1 ? "4px solid #985EAC" : ''}`,
              fontWeight: `${filterBtn == 1 ? "bold" : '400'}`,
              width: 120,
              textAlign: "center",
              cursor: 'pointer'
            }}
            onClick={()=> {
              emandamentoFiltro();
              setFilterBtn(1);
            }}
          >
            Em Andamento
          </div>
          <div
            className="seletores"
            style={{
              marginLeft: 0,
              paddingBottom: 5,
              color: `${filterBtn == 2 ? "#985EAC" : '#565D6D'}`,
              borderBottom: `${filterBtn == 2 ? "4px solid #985EAC" : ''}`,
              fontWeight: `${filterBtn == 2 ? "bold" : '400'}`,
              width: 80,
              textAlign: "center",
              cursor: 'pointer'
            }}
             onClick={()=> {
              concluidosFiltro();
              setFilterBtn(2);
            }}
          >
            Concluído
          </div>
        </div>

        <div className="hidemasternove" style={{  gap: 16 }}>
          <div
            style={{
             backgroundColor: `${corSim == true ?  "#FAEDFF"  :  "#F8F9FA"}`,
              width: 36,
              height: 36,
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: 'pointer'
            }}
            onClick={()=> {
document.querySelector('.gridsistemmaster').style.display = 'none';
document.querySelector('.listsistemmaster').style.display = 'block';
setCorSim(true);
            }}
          >
            <img style={{ width: 14, height: 13 }} src={listicon}/>
          </div>
          <div
            style={{
              backgroundColor: `${corSim == true ? "#F8F9FA"  :  "#FAEDFF"}`,
              width: 36,
              height: 36,
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: 'pointer'
            }}
                 onClick={()=> {
document.querySelector('.gridsistemmaster').style.display = 'flex';
document.querySelector('.listsistemmaster').style.display = 'none';
setCorSim(false);
            }}
          >
            <img style={{ width: 12, height: 15 }} src={gridicon} />
          </div>
        </div>


      </div>





























 
<div
  style={{ marginTop: 30 }}
  className="row wrap gap-4 justify-content-center flex-row gridsistemmaster"
>

            {filtrados.map((data, index)=> {
              return <>
              <div
    className="col-4"
    style={{
      border: "1px solid #DEE1E6",
      borderRadius: 10,
      width: 350,
      height: 267,
      padding: 10
    }}
  >
    <div style={{ display: "flex", justifyContent: "end" }}>
      <div
        className="red"
        style={{
          width: 42,
          height: 24,
          backgroundColor: "#ffc3c7",
          borderRadius: 6,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <img
          src={msgred}
          style={{ width: 10, height: 10, marginRight: 3 }}
        />
        <a style={{ paddingBottom: 2 }}>{Object.keys(data.ordens).length} </a>
      </div>

 {data.andamento ? <>
 
    <div
        className="red"
        style={{
          width: 103,
          height: 24,
          borderRadius: 6,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#FEF9EE",
          margin: "0px 15px"
        }}
      >
        <a
          style={{
            paddingBottom: 2,
            fontSize: 12,
            color: "#98690C",
            fontFamily: "Inter, serif"
          }}
        >
          Em Andamento{" "}
        </a>
      </div>
 </> : <>
 <div
  className="red"
  style={{
    width: 78,
    height: 24,
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#EEFDF3",
    margin: "0px 15px"
  }}
>
  <a
    style={{
      paddingBottom: 2,
      fontSize: 12,
      color: "#117B34",
      fontFamily: "Inter, serif"
    }}
  >
    Concluído{" "}
  </a>
</div>
 
 </> }



   




     <div
                className="red"
                style={{
                  width: 60,
                  height: 24,
                  borderRadius: 6,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgb(238, 238, 238)",
                  margin: "0px 0px"
                 
                }}
              >
                <a
                  style={{
                    paddingBottom: 2,
                    fontSize: 12,
                    color: "#424856",
                    fontFamily: "Inter, serif"
                  }}
                >
                  Criador
                </a>
              </div>








    </div>
    <div style={{ marginTop: 15, marginLeft: 10 }}>
      <div
        className="principalTitle"
        style={{ marginBottom: 18, fontSize: 18 }}
      >
        {data.nomeDoProjeto}
      </div>
      <div className="descricoes" style={{ display: "flex", fontSize: 14 }}>
        <div style={{ marginRight: 10 }}>
          {" "}
          <img style={{ paddingBottom: 3 }} src={atentionicon} />
        </div>
           {data.descricao}
      </div>
      <div
        className="descricoes"
        style={{ display: "flex", marginTop: 10, fontSize: 14 }}
      >
        <div style={{ marginRight: 10 }}>
          {" "}
          <img style={{ paddingBottom: 3 }} src={atentionicon} />
        </div>
           {data.comentariosIniciais}
      </div>
    </div>
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        marginTop: 50
      }}
    >


      {data.urn.length > 2 ? <>
          <div
        className="textobotoes"
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          fontSize: 11,
          alignItems: "center",
          color: "#81379A",
           cursor: 'pointer'
        }}
        onClick={()=> fetchMaster(data.urn)}
      >
        {" "}
        <div
          style={{
            width: 31,
            height: 31,
            backgroundColor: "#985EAC",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
           
          }}
        >
          <img style={{ width: 16, height: 16 }} src={upload3d} />
        </div>
        Viewer 3D
      </div>
      
      </> : <>
      
      {isAdmin && 
            <div
        className="textobotoes"
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          fontSize: 11,
          alignItems: "center",
          color: "#81379A",
           cursor: 'pointer'
        }}
        upload onClick={()=> navigate(`/uploadmaster?idproject=${data.idProjeto}`)}
      >
        {" "}
        <div
          style={{
            width: 31,
            height: 31,
            backgroundColor: "#985EAC",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <img style={{ width: 16, height: 16 }} src={upload3d} />
        </div>
        Upload 3D
      </div>
      
      }
    
      
      
      </>}
  



      <div
        className="textobotoes"
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          fontSize: 11,
          alignItems: "center",
           cursor: 'pointer'
        }}
        ordens onClick={()=> navigate(`/ordens?prjid=${data.idProjeto}`)}
      >
        {" "}
        <div
          style={{
            width: 31,
            height: 31,
            backgroundColor: "#574A69",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <img style={{ width: 16, height: 16 }} src={boxpendencias} />{" "}
        </div>
        Pendências
      </div>
      <div
        className="textobotoes"
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          fontSize: 11,
          alignItems: "center",
           cursor: 'pointer'
        }}
        onClick={()=> { setAberto('flex'); buscarProjeto(data.idProjeto); window.scrollTo(0, 0)}}
      >
        {" "}
        <div
          style={{
            width: 31,
            height: 31,
            backgroundColor: "#574A69",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <img style={{ width: 13, height: 13 }} src={editarprojeto} />
        </div>
        Editar Projeto
      </div>
      <div
        className="textobotoes"
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          fontSize: 11,
          alignItems: "center",
           cursor: 'pointer'
        }}
        onClick={()=> {setTarget(data.idProjeto); setHide('flex'); window.scrollTo(0, 0) } }
      >
        {" "}
        <div
          style={{
            width: 31,
            height: 31,
            backgroundColor: "#574A69",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <img style={{ width: 14, height: 14 }} src={colaboradores} />
        </div>
        Colaboradores
      </div>
    </div>
  </div>  
              
              </>
            })}




            {dataColaborador.map((data,index)=> {
              return <>
                            <div
    className="col-4"
    style={{
      border: "1px solid #DEE1E6",
      borderRadius: 10,
      width: 350,
      height: 267,
      padding: 10
    }}
  >
    <div style={{ display: "flex", justifyContent: "end" }}>
      <div
        className="red"
        style={{
          width: 42,
          height: 24,
          backgroundColor: "#ffc3c7",
          borderRadius: 6,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <img
          src={msgred}
          style={{ width: 10, height: 10, marginRight: 3 }}
        />
        <a style={{ paddingBottom: 2 }}>{Object.keys(data.ordens).length} </a>
      </div>

 {data.andamento ? <>
 
    <div
        className="red"
        style={{
          width: 103,
          height: 24,
          borderRadius: 6,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#FEF9EE",
          margin: "0px 15px"
        }}
      >
        <a
          style={{
            paddingBottom: 2,
            fontSize: 12,
            color: "#98690C",
            fontFamily: "Inter, serif"
          }}
        >
          Em Andamento{" "}
        </a>
      </div>
 </> : <>
 <div
  className="red"
  style={{
    width: 78,
    height: 24,
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#EEFDF3",
    margin: "0px 15px"
  }}
>
  <a
    style={{
      paddingBottom: 2,
      fontSize: 12,
      color: "#117B34",
      fontFamily: "Inter, serif"
    }}
  >
    Concluído{" "}
  </a>
</div>
 
 </> }



   




     <div
                className="red"
                style={{
                  width: 85,
                  height: 24,
                  borderRadius: 6,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgb(238, 238, 238)",
                  margin: "0px 0px"
                 
                }}
              >
                <a
                  style={{
                    paddingBottom: 2,
                    fontSize: 12,
                    color: "#424856",
                    fontFamily: "Inter, serif"
                  }}
                >
                  Colaborador
                </a>
              </div>








    </div>
    <div style={{ marginTop: 15, marginLeft: 10 }}>
      <div
        className="principalTitle"
        style={{ marginBottom: 18, fontSize: 18 }}
      >
        {data.nomeDoProjeto}
      </div>
      <div className="descricoes" style={{ display: "flex", fontSize: 14 }}>
        <div style={{ marginRight: 10 }}>
          {" "}
          <img style={{ paddingBottom: 3 }} src={atentionicon} />
        </div>
           {data.descricao}
      </div>
      <div
        className="descricoes"
        style={{ display: "flex", marginTop: 10, fontSize: 14 }}
      >
        <div style={{ marginRight: 10 }}>
          {" "}
          <img style={{ paddingBottom: 3 }} src={atentionicon} />
        </div>
           {data.comentariosIniciais}
      </div>
    </div>
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        marginTop: 50
      }}
    >


      {data.urn.length > 2 ? <>
          <div
        className="textobotoes"
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          fontSize: 11,
          alignItems: "center",
          color: "#81379A",
           cursor: 'pointer'
        }}
        onClick={()=> fetchMaster(data.urn)}
      >
        {" "}
        <div
          style={{
            width: 31,
            height: 31,
            backgroundColor: "#985EAC",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
           
          }}
        >
          <img style={{ width: 16, height: 16 }} src={upload3d} />
        </div>
        Viewer 3D
      </div>
      
      </> : <>
      
      {isAdmin && 
            <div
        className="textobotoes"
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          fontSize: 11,
          alignItems: "center",
          color: "#81379A",
           cursor: 'pointer'
        }}
        upload onClick={()=> navigate(`/uploadmaster?idproject=${data.idProjeto}`)}
      >
        {" "}
        <div
          style={{
            width: 31,
            height: 31,
            backgroundColor: "#985EAC",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <img style={{ width: 16, height: 16 }} src={upload3d} />
        </div>
        Upload 3D
      </div>
      
      }
    
      
      
      </>}
  



      <div
        className="textobotoes"
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          fontSize: 11,
          alignItems: "center",
           cursor: 'pointer'
        }}
        ordens onClick={()=> navigate(`/ordens?prjid=${data.idProjeto}`)}
      >
        {" "}
        <div
          style={{
            width: 31,
            height: 31,
            backgroundColor: "#574A69",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <img style={{ width: 16, height: 16 }} src={boxpendencias} />{" "}
        </div>
        Pendências
      </div>
      <div
        className="textobotoes"
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          fontSize: 11,
          alignItems: "center",
           cursor: 'pointer'
        }}
        onClick={()=> { setAberto('flex'); buscarProjeto(data.idProjeto); window.scrollTo(0, 0)}}
      >
        {" "}
        <div
          style={{
            width: 31,
            height: 31,
            backgroundColor: "#574A69",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <img style={{ width: 13, height: 13 }} src={editarprojeto} />
        </div>
        Editar Projeto
      </div>
      <div
        className="textobotoes"
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          fontSize: 11,
          alignItems: "center",
           cursor: 'pointer'
        }}
        onClick={()=> {setTarget(data.idProjeto); setHide('flex'); window.scrollTo(0, 0) } }
      >
        {" "}
        <div
          style={{
            width: 31,
            height: 31,
            backgroundColor: "#574A69",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <img style={{ width: 14, height: 14 }} src={colaboradores} />
        </div>
        Colaboradores
      </div>
    </div>
  </div> 
              </>
            })}














</div>




<div className='listsistemmaster'>
      {
        filtrados.map((data, index)=> {
          return <>
                <div style={{ marginTop: 20 }}>
        {" "}
        {/* COL 12 SISTEM */}
        <div
          style={{
            border: "1px #DEE1E6 solid",
            borderRadius: 12,
            padding: 18,
            height: 168
          }}
          className="d-flex"
        >
          <div className="col-6" style={{ borderRight: "1px solid #DEE1E6" }}>
            <div className="principalTitle" style={{ marginBottom: 10 }}>
              {data.nomeDoProjeto}
            </div>
            <div className="descricoes" style={{ display: "flex" }}>
              <div style={{ marginRight: 10 }}>
                {" "}
                <img style={{ paddingBottom: 3 }} src={atentionicon} />
              </div>
              {data.descricao}
            </div>
            <div
              className="descricoes"
              style={{ display: "flex", marginTop: 20 }}
            >
              <div style={{ marginRight: 10 }}>
              
                <img style={{ paddingBottom: 3, marginRight: '10px' }} src={atentionicon} />
                {data.comentariosIniciais}
              </div>

              {data.disciplinas.map((data2, index) => {
    return <> 
    
      <a> {data2}  <a style={{color: 'transparent'}}>.</a></a>
    </>
    })}
             
            </div>
          </div>
          <div
            style={{ display: "flex", flexFlow: "column nowrap" }}
            className="col-6"
          >
            <div style={{ display: "flex", justifyContent: "end" }}>


              <div
                className="red"
                style={{
                  width: 42,
                  height: 24,
                  backgroundColor: "#ffc3c7",
                  borderRadius: 6,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <img
                  src={msgred}
                  style={{ width: 10, height: 10, marginRight: 3 }}
                />
                <a style={{ paddingBottom: 2 }}>{Object.keys(data.ordens).length} </a>
              </div>


              {data.andamento ?
              <div
                className="red"
                style={{
                  width: 103,
                  height: 24,
                  borderRadius: 6,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#FEF9EE",
                  margin: "0px 15px"
                }}
              >
                <a
                  style={{
                    paddingBottom: 2,
                    fontSize: 12,
                    color: "#98690C",
                    fontFamily: "Inter, serif"
                  }}
                >
                 Em Andamento
                </a>
              </div>
                :
                 <div
                className="red"
                style={{
                  width: 80,
                  height: 24,
                  borderRadius: 6,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#EEFDF3",
                  margin: "0px 15px"
                }}
              >
                <a
                  style={{
                    paddingBottom: 2,
                    fontSize: 12,
                    color: "#117B34",
                    fontFamily: "Inter, serif"
                  }}
                >
                  Concluído
                </a>
              </div>
              }







       <div
                className="red"
                style={{
                  width: 60,
                  height: 24,
                  borderRadius: 6,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgb(238, 238, 238)",
                  margin: "0px 0px"
                 
                }}
              >
                <a
                  style={{
                    paddingBottom: 2,
                    fontSize: 12,
                    color: "#424856",
                    fontFamily: "Inter, serif"
                  }}
                >
                  Criador
                </a>
              </div>








            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-around",
                marginTop: 20
              }}
            >
           
              


     {data.urn.length > 2 ? 
              
              
              <>
                    <div
                className="textobotoes"
                style={{
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center",
                  color: "#81379A",
                  cursor: 'pointer'
                }}
                
                onClick={()=> fetchMaster(data.urn)}
              >
                {" "}
                <div
                  style={{
                    width: 42,
                    height: 42,
                    backgroundColor: "#985EAC",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  {" "}
                  <img src={upload3d} />
                </div>
                Viewer 3D
              </div>
          
              </>
              
              
              
              
              : 
              
              
                  <>
                    {
                      isAdmin && <>
                      
                      
                           <div
              className="textobotoes"
              style={{
                display: "flex",
                flexFlow: "column nowrap",
                alignItems: "center",
                color: "#81379A",
                cursor: 'pointer'
              }}
              onClick={()=> navigate(`/uploadmaster?idproject=${data.idProjeto}`)}
            >
              {" "}
              <div
                style={{
                  width: 42,
                  height: 42,
                  backgroundColor: "#985EAC",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                {" "}
                <img src={upload3d} />
              </div>
              Upload 3D
            </div>
              
                      
                      
                      
                       </>
                    }
                  
         
              </>
              
              
              }







            
         
        
              <div
                className="textobotoes"
                style={{
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center",
                  cursor: 'pointer'
                }}
                onClick={()=> navigate(`/ordens?prjid=${data.idProjeto}`)}
              >



                
                {" "}
                <div
                  style={{
                    width: 42,
                    height: 42,
                    backgroundColor: "#574A69",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <img src={boxpendencias} />{" "}
                </div>
                Pendências
              </div>
              <div
                className="textobotoes"
                style={{
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center"
                }}
              >
                {" "}
                <div
                  style={{
                    width: 42,
                    height: 42,
                    backgroundColor: "#574A69",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: 'pointer'
                  }}
                  onClick={()=> { setAberto('flex'); buscarProjeto(data.idProjeto); window.scrollTo(0, 0)}}
                >
                  <img src={editarprojeto} />
                </div>
                Editar Projeto
              </div>
              <div
                className="textobotoes"
                style={{
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center",

                }}
                
              >
                {" "}
                <div
                  style={{
                    width: 42,
                    height: 42,
                    backgroundColor: "#574A69",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: 'pointer'
                  }}
                  onClick={()=> {setTarget(data.idProjeto); setHide('flex'); window.scrollTo(0, 0) } }
                >
                  <img src={colaboradores} />
                </div>
                Colaboradores
              </div>
            </div>
          </div>
        </div>
      </div>
          </>
        })
      }







      {
        dataColaborador.map((data, index)=> {
          return <>
                <div style={{ marginTop: 20 }}>
        {" "}
        {/* COL 12 SISTEM */}
        <div
          style={{
            border: "1px #DEE1E6 solid",
            borderRadius: 12,
            padding: 18,
            height: 168
          }}
          className="d-flex"
        >
          <div className="col-6" style={{ borderRight: "1px solid #DEE1E6" }}>
            <div className="principalTitle" style={{ marginBottom: 10 }}>
              {data.nomeDoProjeto}
            </div>
            <div className="descricoes" style={{ display: "flex" }}>
              <div style={{ marginRight: 10 }}>
                {" "}
                <img style={{ paddingBottom: 3 }} src={atentionicon} />
              </div>
              {data.descricao}
            </div>
            <div
              className="descricoes"
              style={{ display: "flex", marginTop: 20 }}
            >
              <div style={{ marginRight: 10 }}>
              
                <img style={{ paddingBottom: 3, marginRight: '10px' }} src={atentionicon} />
                {data.comentariosIniciais}
              </div>

              {data.disciplinas.map((data2, index) => {
    return <> 
    
      <a> {data2}  <a style={{color: 'transparent'}}>.</a></a>
    </>
    })}
             
            </div>
          </div>
          <div
            style={{ display: "flex", flexFlow: "column nowrap" }}
            className="col-6"
          >
            <div style={{ display: "flex", justifyContent: "end" }}>


              <div
                className="red"
                style={{
                  width: 42,
                  height: 24,
                  backgroundColor: "#ffc3c7",
                  borderRadius: 6,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <img
                  src={msgred}
                  style={{ width: 10, height: 10, marginRight: 3 }}
                />
                <a style={{ paddingBottom: 2 }}>{Object.keys(data.ordens).length} </a>
              </div>


              {data.andamento ?
              <div
                className="red"
                style={{
                  width: 103,
                  height: 24,
                  borderRadius: 6,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#FEF9EE",
                  margin: "0px 15px"
                }}
              >
                <a
                  style={{
                    paddingBottom: 2,
                    fontSize: 12,
                    color: "#98690C",
                    fontFamily: "Inter, serif"
                  }}
                >
                 Em Andamento
                </a>
              </div>
                :
                 <div
                className="red"
                style={{
                  width: 80,
                  height: 24,
                  borderRadius: 6,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#EEFDF3",
                  margin: "0px 15px"
                }}
              >
                <a
                  style={{
                    paddingBottom: 2,
                    fontSize: 12,
                    color: "#117B34",
                    fontFamily: "Inter, serif"
                  }}
                >
                  Concluído
                </a>
              </div>
              }






 <div
                className="red"
                style={{
                  width: 85,
                  height: 24,
                  borderRadius: 6,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgb(238, 238, 238)",
                  margin: "0px 0px"
                 
                }}
              >
                <a
                  style={{
                    paddingBottom: 2,
                    fontSize: 12,
                    color: "#424856",
                    fontFamily: "Inter, serif"
                  }}
                >
                  Colaborador
                </a>
              </div>









            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-around",
                marginTop: 20
              }}
            >
           
              


     {data.urn.length > 2 ? 
              
              
              <>
                    <div
                className="textobotoes"
                style={{
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center",
                  color: "#81379A",
                  cursor: 'pointer'
                }}
                
                onClick={()=> fetchMaster(data.urn)}
              >
                {" "}
                <div
                  style={{
                    width: 42,
                    height: 42,
                    backgroundColor: "#985EAC",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  {" "}
                  <img src={upload3d} />
                </div>
                Viewer 3D
              </div>
          
              </>
              
              
              
              
              : 
              
              
                  <>
                    {
                      isAdmin && <>
                      
                      
                           <div
              className="textobotoes"
              style={{
                display: "flex",
                flexFlow: "column nowrap",
                alignItems: "center",
                color: "#81379A",
                cursor: 'pointer'
              }}
              onClick={()=> navigate(`/uploadmaster?idproject=${data.idProjeto}`)}
            >
              {" "}
              <div
                style={{
                  width: 42,
                  height: 42,
                  backgroundColor: "#985EAC",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                {" "}
                <img src={upload3d} />
              </div>
              Upload 3D
            </div>
              
                      
                      
                      
                       </>
                    }
                  
         
              </>
              
              
              }







            
         
        
              <div
                className="textobotoes"
                style={{
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center",
                  cursor: 'pointer'
                }}
                onClick={()=> navigate(`/ordens?prjid=${data.idProjeto}`)}
              >



                
                {" "}
                <div
                  style={{
                    width: 42,
                    height: 42,
                    backgroundColor: "#574A69",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <img src={boxpendencias} />{" "}
                </div>
                Pendências
              </div>
              <div
                className="textobotoes"
                style={{
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center"
                }}
              >
                {" "}
                <div
                  style={{
                    width: 42,
                    height: 42,
                    backgroundColor: "#574A69",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: 'pointer'
                  }}
                  onClick={()=> { setAberto('flex'); buscarProjeto(data.idProjeto); window.scrollTo(0, 0)}}
                >
                  <img src={editarprojeto} />
                </div>
                Editar Projeto
              </div>
              <div
                className="textobotoes"
                style={{
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center",

                }}
                
              >
                {" "}
                <div
                  style={{
                    width: 42,
                    height: 42,
                    backgroundColor: "#574A69",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: 'pointer'
                  }}
                  onClick={()=> {setTarget(data.idProjeto); setHide('flex'); window.scrollTo(0, 0) } }
                >
                  <img src={colaboradores} />
                </div>
                Colaboradores
              </div>
            </div>
          </div>
        </div>
      </div>
          </>
        })
      }

</div>






    </div>
  </div>
</div>









        </div>


      <Rodape/>


        </>
    )
}
export default Main;
